<template>
  <div class="container">
    <content-header :data="[{text: '投票活动一览', path: '/vote/list'},{text: voteName+' 礼物管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="礼物">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:102px;height:36px":src="scope.row.imageUrl" v-if="scope.row.imageUrl"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="point"
            label="点数">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改礼物' : '添加礼物'" width="50%" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm">
            <el-form-item prop="presentId" label="选择礼物" :label-width="formLabelWidth">
              <el-select v-model="curObj.presentId" value-key="id" filterable placeholder="请选择"
              >
                <el-option
                  v-for="item in presentOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import VoteModel from 'models/vote'

  export default {
    data () {
      return {
        tableData: [],
        voteId: '',
        voteName: '',
        curObj: {
          id: '',
          voteId: '',
          presentId: ''
        },
        curObjRules: {
          presentId: [{ required: true, message: '请选择礼物', trigger: 'blur' }],
        },
        isObjShow: false,
        formLabelWidth: '80px',
        //
        presentOpts: [],
      }
    },
    created () {
      this.voteId = this.$route.query.id
      this.voteName = this.$route.query.name
      this.getObjList()
      //
      VoteModel.findPresentAll({curPage: 1, pageSize: 1000, keywords: ''}).then(res => {
        this.presentOpts = res.rows
      })
    },
    computed: {
    },
    methods: {
      getObjList () {
        VoteModel.findPresentXref({voteId: this.voteId}).then(res => {
          this.tableData = res
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            VoteModel.deletePresentXref({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          presentId: '',
          voteId: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        VoteModel.createPresentXref({
          presentId: this.curObj.presentId,
          voteId: this.voteId
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          presentId: item.row.presentId,
          voteId: this.voteId
        }
        this.isObjShow = true
      },
      editHandle () {
        VoteModel.updatePresentXref({
          id: this.curObj.id,
          presentId: this.curObj.presentId,
          voteId: this.voteId
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 180px
            height: 90px
            line-height: 90px
            text-align: center
          .avatar
            width: 180px
            height: 90px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/VotePresentXref.vue